import styled from 'styled-components'

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`

export const Group = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${props => props.theme.spacing.sp24};
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
